import React from 'react';
import { activeSearchFilters } from '../utils/activeSearchFilters';
import './ActiveSearchFilters.css';
export default function ActiveSearchFilters({filters, searching, busy, onRemove}) {
  if(!filters)return null;
  const chips=activeSearchFilters(filters);
  return <section className="active-search-filters" aria-label="Active search filters" aria-busy={searching}>
    <div className="active-search-heading"><strong>{searching?'Searching with':'Search filters'}</strong><span>Active listings{filters.allPropertySubTypes?' · Any home type':!filters.propertySubType?' · Houses, condos & townhouses':''}</span></div>
    <div className="active-search-chips">{chips.map(chip=><button type="button" key={chip.keys.join(',')} disabled={busy} title={`Remove ${chip.name.toLowerCase()} filter`} aria-label={`Remove ${chip.name.toLowerCase()} filter`} onClick={()=>onRemove(chip)}><span>{chip.label}</span><span aria-hidden="true">×</span></button>)}</div>
    <p>Tap × or ask to remove a filter.</p>
  </section>;
}
